/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import MapIcon from "@mui/icons-material/Map";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import WifiIcon from "@mui/icons-material/Wifi";
import { LazyLoadImage } from "react-lazy-load-image-component";
import toast from "react-hot-toast";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Divider,
  Rating,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";

const API = process.env.REACT_APP_API_URL;
const HomePage = () => {
  const { isAuthenticated, role } = useContext(AuthContext);
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [achievements, setAchievements] = useState([]);
  const [selectedAchievement, setSelectedAchievement] = useState(null);
  const [showAllAchievements, setShowAllAchievements] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [showLibraryVideo, setShowLibraryVideo] = useState(false);

  useEffect(() => {
    if (isAuthenticated()) {
      if (role === "admin") navigate("/admin/dashboard");
      else navigate("/student/dashboard");
    }
  }, [isAuthenticated, role, navigate]);

  // Fixed: Ensure API data is always an array
  const fetchReviews = async () => {
    try {
      const res = await axios.get(`${API}reviews/`);
      setTestimonials(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      toast.error("Failed to fetch reviews");
      setTestimonials([]);
    }
  };

  const fetchAchievements = async () => {
    try {
      const res = await axios.get(`${API}achievements/`);
      setAchievements(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Failed to fetch achievements:", err);
      setAchievements([]);
    }
  };

  useEffect(() => {
    fetchReviews();
    fetchAchievements();
  }, []);

  // Auto-slide effect for achievements
  useEffect(() => {
    if (achievements.length > 0) {
      const interval = setInterval(() => {}, 50);
      return () => clearInterval(interval);
    }
  }, [achievements.length]);

  const services = [
    {
      title: "Live Seat Mapping",
      icon: <MapIcon className="text-green-600" style={{ fontSize: "40px" }} />,
      desc: "View and choose live seat positions across study center maps.",
    },
    {
      title: "Air Conditioner premises",
      icon: <MapIcon className="text-green-600" style={{ fontSize: "40px" }} />,
      desc: "Study in cool environment with cool mind",
    },
    {
      title: "Study Centre Booking",
      icon: (
        <MeetingRoomIcon
          className="text-purple-600"
          style={{ fontSize: "40px" }}
        />
      ),
      desc: "Reserve study centre rooms or spaces for focused academic time.",
    },
    {
      title: "Monthly Billing & Invoices",
      icon: (
        <ReceiptLongIcon
          className="text-orange-600"
          style={{ fontSize: "40px" }}
        />
      ),
      desc: "Track monthly fees and download detailed invoices anytime.",
    },
    {
      title: "Spacious Study Halls",
      icon: (
        <MeetingRoomOutlinedIcon
          className="text-pink-600"
          style={{ fontSize: "40px" }}
        />
      ),
      desc: "Enjoy quiet, comfortable, and distraction-free study environments.",
    },
    {
      title: "High-Speed Wi-Fi",
      icon: (
        <WifiIcon className="text-indigo-600" style={{ fontSize: "40px" }} />
      ),
      desc: "Stay connected with fast and reliable internet access throughout.",
    },
  ];

  const images = [
    { title: "Library", seed: "library0.png" },
    { title: "Library Desk", seed: "library1.jpeg" },
    { title: "Library Facility", seed: "library2.jpeg" },
    { title: "Library Space", seed: "library3.jpeg" },
    { title: "Library", seed: "library4.jpeg" },
    { title: "Library View", seed: "library5.jpeg" },
    { title: "Library", seed: "library6.jpeg" },
    { title: "Library Entrance", seed: "entrance1.png" },
    { title: "Library Entrance", seed: "entrance2.png" },
    { title: "Office", seed: "office4.png" },
    { title: "Office", seed: "office3.png" },
    { title: "Library Entrance", seed: "office2.png" },
    { title: "Library Entrance", seed: "office1.png" },
    { title: "view", seed: "view2.jpeg" },
    { title: "Washroom", seed: "washroom1.png" },
  ];

  const marqueeRef = useRef(null);
  const marqueeRef1 = useRef(null);
  const [duration, setDuration] = useState(0);
  const [duration1, setDuration1] = useState(0);

  useEffect(() => {
    if (marqueeRef1.current) {
      const scrollWidth = marqueeRef1.current.scrollWidth;
      const speedPerPixel = 0.02;
      setDuration1(scrollWidth * speedPerPixel);
    }
  }, [achievements]);

  useEffect(() => {
    if (marqueeRef.current) {
      const scrollWidth = marqueeRef.current.scrollWidth;
      const speedPerPixel = 0.02;
      setDuration(scrollWidth * speedPerPixel);
    }
  }, [testimonials]);

  const heroImages = [
    "/images/library0.png",
    "/images/library1.jpeg",
    "/images/library2.jpeg",
    "/images/library3.jpeg",
    "/images/library5.jpeg",
    "/images/library6.jpeg",
    "/images/library7.jpeg",
    "/images/library8.jpeg",
  ];
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  const [formData, setFormData] = useState({
    first_name: "",
    email: "",
    phone: "",
    description: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading("Sending message...");

    try {
      await axios.post(`${API}contactus/`, formData);
      toast.success("✅ Message sent!", { id: loadingToast });
      setFormData({ first_name: "", email: "", phone: "", description: "" });
    } catch (err) {
      toast.error("❌ Failed to send message", { id: loadingToast });
    }
  };
  return (
    <div className="font-sans text-gray-700 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Header */}
      <header className="sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-gray-200 shadow-sm">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center py-4 px-4 sm:px-8 md:px-16 lg:px-36">
          <div className="flex gap-4 items-center justify-center sm:justify-start">
            <div className="relative">
              <img
                src={`/images/logo3.png`}
                alt="Bussiness Track"
                className="w-12 h-12"
              />
            </div>
            <h1 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent text-center sm:text-left">
              Prof. S. S. Patil Study Center
            </h1>
          </div>

          <div className="mt-3 sm:mt-0 flex justify-center sm:justify-end space-x-4 sm:space-x-6">
            <button
              onClick={() => navigate("/login")}
              className="px-4 sm:px-6 py-2 text-sm sm:text-base md:text-lg font-medium text-blue-600 hover:text-blue-700 transition-colors duration-200 hover:bg-blue-50 rounded-lg"
            >
              Login
            </button>
            <button
              onClick={() => navigate("/register")}
              className="px-4 sm:px-6 py-2 text-sm sm:text-base md:text-lg font-medium bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
            >
              Register
            </button>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative w-full h-[600px] sm:h-[700px] md:h-[800px] overflow-hidden">
        {/* Rotating Backgrounds */}
        {heroImages.map((img, index) => (
          <div
            key={index}
            className={`absolute top-0 left-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 ease-in-out ${
              index === currentImage ? "opacity-100 z-0" : "opacity-0 z-0"
            }`}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}

        {/* Enhanced Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-black/40 z-10"></div>

        {/* Content */}
        <div className="relative z-20 flex flex-col items-center sm:items-start justify-center h-full px-6 sm:px-8 md:px-16 lg:px-36 text-center sm:text-left">
          <div className="max-w-2xl">
            <div className="w-full flex justify-center sm:justify-start mb-6">
              <div className="relative">
                <img
                  src="images/logo3.png"
                  alt="Logo"
                  className="w-20 h-20 sm:w-24 sm:h-24 md:w-36 md:h-36 drop-shadow-2xl animate-bounce"
                  style={{ animationDuration: "3s" }}
                />
              </div>
            </div>

            <div className="space-y-4 sm:space-y-6">
              <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full shadow-sm border border-white/30">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-xs sm:text-sm font-medium text-white">
                  Welcome to Excellence
                </span>
              </div>

              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
                Prof. S. S. Patil <br className="hidden sm:block" />
                <span className="bg-gradient-to-r from-blue-300 to-indigo-300 bg-clip-text text-transparent">
                  Study Center
                </span>
              </h2>

              <p className="text-base sm:text-lg md:text-xl text-gray-100 leading-relaxed max-w-xl">
                Your ideal space for focused learning and comfortable living.
                Designed with brilliance, we offer a peaceful study environment,
                environment, modern amenities, and a secure, homely atmosphere
                to help you succeed academically and personally.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Student Achievements */}
      {achievements.length > 0 && (
        <section className="relative overflow-hidden bg-gradient-to-br from-white via-blue-50 to-indigo-50 py-12 sm:py-16 md:py-20 px-4 sm:px-8 md:px-16 lg:px-36">
          {/* Background decorative elements */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-20 left-20 w-40 h-40 bg-yellow-400 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-20 w-32 h-32 bg-orange-400 rounded-full blur-3xl"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-red-400 rounded-full blur-2xl"></div>
          </div>

          <div className="relative w-full mx-auto">
            <div className="text-center mb-12 sm:mb-16">
              <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm border border-yellow-100 mb-4">
                <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
                <span className="text-xs sm:text-sm font-medium text-gray-700">
                  Student Success Stories
                </span>
              </div>
              <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-yellow-600 to-orange-600 bg-clip-text text-transparent mb-4">
                Blogs & Achievers
              </h3>
              <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
                Discover the inspiring Blogs and stories of our students who have achieved
                remarkable success in their academic and personal journeys.
              </p>
              <div className="w-20 h-1 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-full mx-auto mt-6"></div>
            </div>

            <div className="relative w-full overflow-hidden py-6">
              <div
                ref={marqueeRef1}
                className="flex items-center justify-between gap-4 sm:gap-6 md:gap-8 w-full"
                style={{
                  animation: `marquee1 ${duration1}s linear infinite`,
                }}
              >
                {achievements.map((achievement, index) => (
                  <div
                    key={achievement.id}
                    className="group relative min-w-[280px] sm:min-w-[320px] md:min-w-[350px] max-w-[400px] bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/50 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden cursor-pointer flex-shrink-0"
                    onClick={() => setSelectedAchievement(achievement)}
                  >
                    {/* Decorative gradient overlay */}
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-500 to-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                    {/* Achievement badge */}
                    <div className="absolute top-4 right-4 z-10">
                      <div className="w-12 h-12 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
                        <svg
                          className="w-6 h-6 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                          ></path>
                        </svg>
                      </div>
                    </div>

                    {/* Square Image section */}
                    <div className="relative aspect-square overflow-hidden rounded-t-2xl">
                      {achievement.images ? (
                        <LazyLoadImage
                          src={achievement.images}
                          alt={achievement.title}
                          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        />
                      ) : (
                        <div className="w-full h-full bg-gradient-to-br from-yellow-100 to-orange-100 flex items-center justify-center">
                          <svg
                            className="w-16 h-16 text-yellow-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                            ></path>
                          </svg>
                        </div>
                      )}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                    </div>

                    {/* Content section */}
                    <div className="p-6">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
                        <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Achievement
                        </span>
                      </div>

                      <h4 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-yellow-600 transition-colors duration-300 line-clamp-2">
                        {achievement.title}
                      </h4>

                      <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                        {achievement.description}
                      </p>

                      {/* Date and decorative elements */}
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2 text-xs text-gray-500">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            ></path>
                          </svg>
                          <span>
                            {new Date(
                              achievement.created_at
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </span>
                        </div>

                        <div className="flex items-center gap-1">
                          <div className="w-1 h-1 bg-yellow-500 rounded-full"></div>
                          <div className="w-1 h-1 bg-orange-500 rounded-full"></div>
                          <div className="w-1 h-1 bg-red-500 rounded-full"></div>
                        </div>
                      </div>
                    </div>

                    {/* Hover effect overlay */}
                    <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/5 to-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
                  </div>
                ))}
              </div>
            </div>

            {/* View All Achievements Button */}
            <div className="text-center mt-12">
              <button
                onClick={() => setShowAllAchievements(true)}
                className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-semibold rounded-xl hover:from-yellow-600 hover:to-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  ></path>
                </svg>
                View All
              </button>
            </div>
          </div>
        </section>
      )}
      <style>
        {`
            @keyframes marquee1 {
              0% { transform: translateX(100%); }
              100% { transform: translateX(-140%); }
            }
            @media (max-width: 640px) {
              @keyframes marquee1 {
                0% { transform: translateX(120%); }
                100% { transform: translateX(-180%); }
              }
            }
            @media (min-width: 641px) and (max-width: 1024px) {
              @keyframes marquee1 {
                0% { transform: translateX(110%); }
                100% { transform: translateX(-160%); }
              }
            }
              `}
      </style>

      {/* Dream Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8">
        {/* Background decorative elements */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-32 h-32 bg-blue-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-indigo-400 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-purple-400 rounded-full blur-2xl"></div>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-12 lg:gap-16">
            {/* Image Section */}
            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-500"></div>
              <div className="relative">
                <img
                  src="images/APJKALAM.png"
                  alt="Father"
                  className="rounded-2xl shadow-2xl w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80 object-contain object-center transform group-hover:scale-105 transition duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
              </div>
            </div>

            {/* Content Section */}
            <div className="flex-1 text-center lg:text-left space-y-4 sm:space-y-6">
              <div className="space-y-3 sm:space-y-4">
                <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm border border-blue-100">
                  <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                  <span className="text-xs sm:text-sm font-medium text-gray-700">
                    In Loving Memory
                  </span>
                </div>

                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent leading-tight">
                  Of Our Beloved
                </h2>
                <h3 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-gray-800 leading-tight">
                  LATE DR. A.P.J. ABDUL KALAM
                </h3>

                <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mx-auto lg:mx-0"></div>
              </div>

              <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-gray-700 leading-relaxed">
                <p className="font-medium">
                  This study centre is a dream brought to life,
                  inspired by his values and vision.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 pt-4">
                  <div className="text-center p-4 bg-white/60 backdrop-blur-sm rounded-xl shadow-sm border border-blue-100">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <svg
                        className="w-6 h-6 text-blue-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                        ></path>
                      </svg>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-1">Vision</h4>
                    <p className="text-sm text-gray-600">
                      His dream of quality education
                    </p>
                  </div>

                  <div className="text-center p-4 bg-white/60 backdrop-blur-sm rounded-xl shadow-sm border border-blue-100">
                    <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <svg
                        className="w-6 h-6 text-indigo-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                        ></path>
                      </svg>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-1">Love</h4>
                    <p className="text-sm text-gray-600">
                      Unwavering support & care
                    </p>
                  </div>

                  <div className="text-center p-4 bg-white/60 backdrop-blur-sm rounded-xl shadow-sm border border-blue-100">
                    <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <svg
                        className="w-6 h-6 text-purple-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                        ></path>
                      </svg>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-1">Wisdom</h4>
                    <p className="text-sm text-gray-600">
                      Guidance that lights our path
                    </p>
                  </div>
                </div>

                <p className="text-gray-600 italic">
                  "His unwavering support, guidance, and belief in the power of
                  education continue to light our path and inspire every student
                  who walks through these doors."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>



{/* Library Video Section */}
<section className="px-4 sm:px-8 md:px-16 lg:px-36 py-12 sm:py-16 md:py-20 bg-white">
  <div className="text-center mb-8 sm:mb-12">
    <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-blue-50 rounded-full shadow-sm border border-blue-100 mb-4">
      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
      <span className="text-xs sm:text-sm font-medium text-gray-700">
        Library Tour
      </span>
    </div>

    <h3 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4">
      Explore Our Library
    </h3>
    <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mx-auto"></div>

    <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
      Take a quick look at our peaceful library space, seating, lighting, and study environment.
    </p>
  </div>

  <div className="max-w-5xl mx-auto">
    <div
      onClick={() => setShowLibraryVideo(true)}
      className="group relative cursor-pointer overflow-hidden rounded-2xl shadow-xl border border-gray-100"
    >
      {/* Thumbnail */}
      <img
        src="/images/library1.jpeg"
        alt="Library video thumbnail"
        className="w-full h-[220px] sm:h-[320px] md:h-[420px] object-cover group-hover:scale-105 transition-transform duration-700"
      />

      {/* overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>

      {/* Play button */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300">
          <svg
            className="w-7 h-7 sm:w-9 sm:h-9 text-blue-600"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M6 4l12 6-12 6V4z" />
          </svg>
        </div>
      </div>

      {/* Bottom text */}
      <div className="absolute bottom-0 left-0 right-0 p-6">
        <h4 className="text-white font-bold text-xl">Watch Library Walkthrough</h4>
        <p className="text-white/80 text-sm mt-1">Click to play</p>
      </div>
    </div>
  </div>
</section>

      {/* Gallery */}
      <section className="px-4 sm:px-8 md:px-16 lg:px-36 py-12 sm:py-16 md:py-20 bg-gradient-to-br from-white via-blue-50 to-indigo-50">
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm border border-blue-100 mb-4">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            <span className="text-xs sm:text-sm font-medium text-gray-700">
              Our Facilities
            </span>
          </div>
          <h3 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4">
            Explore Our Campus
          </h3>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {images.map((img, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer transform hover:-translate-y-2 transition-all duration-500"
              onClick={() => setPreviewImage(`${img.seed}`)}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent z-10"></div>
              <LazyLoadImage
                src={`/images/${img.seed}`}
                alt={img.title}
                className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 z-20">
                <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-200 transition-colors">
                  {img.title}
                </h4>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-0.5 bg-blue-400 rounded-full"></div>
                </div>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <svg
                  className="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                  ></path>
                </svg>
              </div>
            </div>
          ))}
        </div>
      </section>

      {previewImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 cursor-zoom-out"
          onClick={() => setPreviewImage(null)}
        >
          <img
            // src={previewImage}
            src={`/images/${previewImage}`}
            alt="Preview"
            className="max-w-[90%] max-h-[90%] rounded-lg"
          />
        </div>
      )}

      {/* Why Choose Us */}
      <section className="px-4 sm:px-8 md:px-16 lg:px-36 py-12 sm:py-16 md:py-20 bg-gradient-to-br from-blue-50 via-white to-indigo-50 relative overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-20 w-40 h-40 bg-blue-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-32 h-32 bg-indigo-400 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-purple-400 rounded-full blur-2xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm border border-blue-100 mb-4">
              <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
              <span className="text-xs sm:text-sm font-medium text-gray-700">
                Our Advantages
              </span>
            </div>
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4">
              Why Choose Prof. S. S. Patil Study Center?
            </h3>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Experience the perfect blend of academic excellence and
              comfortable living. We provide everything you need to succeed in
              your educational journey.
            </p>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mx-auto mt-6"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12">
            {/* Feature 1 - 24/7 CCTV */}
            <div className="group relative bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg border border-white/50 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-t-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-800">
                    24/7 CCTV Surveillance
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Round-the-clock monitoring
                  </p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Complete security coverage with 24/7 CCTV surveillance system
                ensuring your safety and peace of mind throughout your stay.
              </p>
            </div>

            {/* Feature 2 - 24/7 Electricity and Water */}
            <div className="group relative bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg border border-white/50 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-500 to-emerald-600 rounded-t-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-800">
                    24/7 Electricity & Water
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Uninterrupted utilities
                  </p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Enjoy uninterrupted electricity and water supply 24/7. No more
                worries about power cuts or water shortages during your studies.
              </p>
            </div>

            {/* Feature 3 - 24/7 Aqua Water */}
            <div className="group relative bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg border border-white/50 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-t-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-800">
                    24/7 Aqua Water
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Normal & cool water available
                  </p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Pure aqua water available 24/7 with both normal and cool water
                options. Stay hydrated with clean, filtered water anytime.
              </p>
            </div>

            {/* Last two features centered */}
            <div className="sm:col-span-2 lg:col-span-3 flex justify-center items-center flex-col sm:flex-row gap-6 sm:gap-8 w-full">
              {/* Feature 7 - Special and Secure Parking */}
              <div className="group relative bg-white/80 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-lg border border-white/50 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 w-full max-w-sm sm:max-w-md">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-500 to-orange-600 rounded-t-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r from-yellow-500 to-orange-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <svg
                      className="w-6 h-6 sm:w-8 sm:h-8 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg sm:text-xl font-bold text-gray-800">
                      Special & Secure Parking
                    </h4>
                    <p className="text-gray-600 text-xs sm:text-sm">
                      Safe vehicle storage
                    </p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                  Dedicated parking space with 24/7 security monitoring. Your
                  vehicles are safe and protected in our specially designed
                  parking area.
                </p>
              </div>

              {/* Feature 8 - Study Centre with Superior Amenities */}
              <div className="group relative bg-white/80 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-lg border border-white/50 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 w-full max-w-sm sm:max-w-md">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <svg
                      className="w-6 h-6 sm:w-8 sm:h-8 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg sm:text-xl font-bold text-gray-800">
                      Study Centre with Superior Amenities
                    </h4>
                    <p className="text-gray-600 text-xs sm:text-sm">
                      Optimal learning environment
                    </p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                  State-of-the-art study centre equipped with modern facilities,
                  comfortable seating, high-speed internet, and quiet zones for
                  focused learning.
                </p>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <div className="inline-flex items-center gap-4 p-8 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl shadow-2xl">
              <div className="text-white">
                <h4 className="text-2xl font-bold mb-2">Ready to Join Us?</h4>
                <p className="text-blue-100 mb-4">
                  Start your academic journey with the best facilities and
                  support
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <button
                    onClick={() => navigate("/register")}
                    className="px-8 py-3 bg-white text-blue-600 font-semibold rounded-xl hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                  >
                    Register Now
                  </button>
                  <button
                    onClick={() => {
                      document.getElementById("contact").scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }}
                    className="px-8 py-3 border-2 border-white text-white font-semibold rounded-xl hover:bg-white hover:text-blue-600 transition-all duration-300"
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="px-4 sm:px-8 md:px-16 lg:px-36 py-12 sm:py-16 md:py-20 bg-white">
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-blue-50 rounded-full shadow-sm border border-blue-100 mb-4">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            <span className="text-xs sm:text-sm font-medium text-gray-700">
              What We Offer
            </span>
          </div>
          <h3 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4">
            Our Premium Services
          </h3>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, i) => (
            <div
              key={i}
              className="group relative bg-white border border-gray-100 px-8 py-10 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 hover-lift"
            >
              {/* Background gradient on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              {/* Decorative corner elements */}
              <div className="absolute top-0 left-0 w-8 h-8 border-l-2 border-t-2 border-blue-400 rounded-tl-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute bottom-0 right-0 w-8 h-8 border-r-2 border-b-2 border-indigo-400 rounded-br-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div className="relative z-10">
                <div className="mb-6 flex justify-center">
                  <div className="relative">
                    <div className="absolute -inset-2 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-full blur opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
                    <div className="relative bg-white p-4 rounded-full shadow-md group-hover:shadow-lg transition-shadow duration-500 group-hover:scale-110 transition-transform duration-300">
                      {service.icon}
                    </div>
                  </div>
                </div>

                <h4 className="font-bold text-gray-800 text-xl mb-3 text-center group-hover:text-blue-600 transition-colors duration-300">
                  {service.title}
                </h4>

                <p className="text-gray-600 text-base text-center leading-relaxed group-hover:text-gray-700 transition-colors duration-300">
                  {service.desc}
                </p>

                <div className="mt-6 flex justify-center">
                  <div className="w-12 h-0.5 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full group-hover:w-16 transition-all duration-300"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      {testimonials.length > 0 && (
        <section className="px-4 sm:px-8 md:px-16 lg:px-36 py-12 sm:py-16 md:py-20 bg-gradient-to-br from-gray-50 to-blue-50 text-center overflow-hidden">
          <div className="text-center mb-8 sm:mb-12">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm border border-blue-100 mb-4">
              <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
              <span className="text-xs sm:text-sm font-medium text-gray-700">
                Student Reviews
              </span>
            </div>
            <h3 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4">
              What Students Say
            </h3>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mx-auto"></div>
          </div>

          <div className="relative w-full overflow-hidden py-6">
            <div
              ref={marqueeRef}
              className="flex items-center justify-between gap-4 sm:gap-6 md:gap-8 w-full"
              style={{
                animation: `marquee ${duration}s linear infinite`,
              }}
            >
              {testimonials.map((t, i) => (
                <div
                  key={t.id}
                  onClick={() => setSelectedReview(t)}
                  className="group relative min-w-[250px] sm:min-w-[280px] md:min-w-[300px] max-w-[400px] h-[250px] sm:h-[280px] py-6 sm:py-8 px-6 sm:px-8 rounded-2xl shadow-lg bg-white/80 backdrop-blur-sm border border-white/50 hover:bg-white hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer"
                >
                  {/* Decorative elements */}
                  <div className="absolute top-4 right-4 w-8 h-8 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-full opacity-20 group-hover:opacity-40 transition-opacity duration-300"></div>
                  <div className="absolute bottom-4 left-4 w-6 h-6 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full opacity-20 group-hover:opacity-40 transition-opacity duration-300"></div>

                  <div className="relative z-10 flex flex-col justify-center items-center gap-4 h-full">
                    <div className="text-center">
                      <h4 className="font-bold text-gray-800 text-xl mb-2 group-hover:text-blue-600 transition-colors duration-300 line-clamp-1">
                        {t.title}
                      </h4>

                      <div className="flex justify-center mb-4">
                        <span className="text-yellow-500 text-2xl">
                          {"★".repeat(t.rating)}
                          {"☆".repeat(5 - t.rating)}
                        </span>
                      </div>
                    </div>

                    <div className="relative">
                      <p className="text-gray-600 text-base leading-relaxed line-clamp-4 group-hover:text-gray-700 transition-colors duration-300">
                        {t.description}
                      </p>
                    </div>

                    <div className="mt-auto">
                      <span className="text-base font-semibold text-gray-800 capitalize group-hover:text-blue-600 transition-colors duration-300">
                        — {t.name}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Custom CSS in JSX */}
          <style>
            {`
          @keyframes marquee {
            0% { transform: translateX(100%); }
            100% { transform: translateX(-100%); }
          }
            @media (max-width: 640px) {
              @keyframes marquee {
                0% { transform: translateX(120%); }
                100% { transform: translateX(-180%); }
              }
            }
            @media (min-width: 641px) and (max-width: 1024px) {
              @keyframes marquee {
                0% { transform: translateX(110%); }
                100% { transform: translateX(-160%); }
              }
            }

          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }

          @keyframes glow {
            0%, 100% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.3); }
            50% { box-shadow: 0 0 30px rgba(59, 130, 246, 0.6); }
          }

          .animate-float {
            animation: float 3s ease-in-out infinite;
          }

          .animate-glow {
            animation: glow 2s ease-in-out infinite;
          }

          .glass-effect {
            backdrop-filter: blur(10px);
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }

          .gradient-text {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .hover-lift {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .hover-lift:hover {
            transform: translateY(-5px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          }

          .line-clamp-2 {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .line-clamp-3 {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .line-clamp-4 {
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        `}
          </style>
        </section>
      )}

      {/* Contact Us */}
      <section
        id="contact"
        className="px-4 sm:px-8 md:px-16 lg:px-36 py-12 sm:py-16 md:py-20 bg-gradient-to-br from-white via-blue-50 to-indigo-50"
      >
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm border border-blue-100 mb-4">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span className="text-xs sm:text-sm font-medium text-gray-700">
              Get In Touch
            </span>
          </div>
          <h3 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4">
            Contact Us
          </h3>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mx-auto"></div>
        </div>

        <div className="flex flex-col lg:flex-row justify-center items-start gap-8 sm:gap-12 lg:gap-16 max-w-6xl mx-auto">
          {/* Contact Form */}
          <div className="bg-white/80 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-white/50 w-full lg:w-1/2">
            <h4 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-6">
              Send us a Message
            </h4>
            <form className="space-y-4 sm:space-y-6" onSubmit={handleSubmit}>
              <div className="relative">
                <input
                  className="w-full border border-gray-200 pl-10 pr-6 py-4 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white/50 backdrop-blur-sm"
                  placeholder="Your Name"
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    ></path>
                  </svg>
                </div>
              </div>

              <div className="relative">
                <input
                  className="w-full border border-gray-200 pl-10 pr-6 py-4 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white/50 backdrop-blur-sm"
                  placeholder="Email Address"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    ></path>
                  </svg>
                </div>
              </div>

              <div className="relative">
                <input
                  className="w-full border border-gray-200 pl-10 pr-6 py-4 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white/50 backdrop-blur-sm"
                  placeholder="Phone Number"
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    ></path>
                  </svg>
                </div>
              </div>

              <div className="relative">
                <textarea
                  className="w-full border border-gray-200 pl-10 pr-6 py-4 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-white/50 backdrop-blur-sm resize-none"
                  placeholder="Your Message"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows="4"
                  required
                ></textarea>
                <div className="absolute top-4 left-3 flex items-center pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                    ></path>
                  </svg>
                </div>
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Info & Map */}
          <div className="text-base text-gray-700 w-full lg:w-1/2 space-y-6 sm:space-y-8">
            <div className="bg-white/80 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-white/50">
              <h4 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">
                Prof. S. S. Patil Study Center
              </h4>
              <p className="text-gray-600 mb-4 sm:mb-6 italic">
                Where Comfort Meets Concentration
              </p>

              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start gap-4 p-4 bg-white/50 rounded-xl hover:bg-white/70 transition-colors duration-300">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                    <MailOutlineIcon className="text-blue-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">Email</p>
                    <p className="text-gray-600">admin@profsspatilstudycenter.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-white/50 rounded-xl hover:bg-white/70 transition-colors duration-300">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <PhoneAndroidIcon className="text-green-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">Phone</p>
                    <p className="text-gray-600">+91 9890741579 / 9766741579</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-white/50 rounded-xl hover:bg-white/70 transition-colors duration-300">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                    <LocationOnIcon className="text-purple-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">Address</p>
                    <p className="text-gray-600">
                      SHRI PARVATI BUILDING, MANTRY COLONY RIKSHA STOP, <br />  KARMVEER NAGAR -3, K.B.P. COLLEGE ROAD,
                      URUN ISHWARPUR, TAL: WALWA, DIST: SANGLI, MAHARASHTRA INDIA 415409
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white/80 backdrop-blur-sm p-4 rounded-2xl shadow-xl border border-white/50 overflow-hidden">
              <iframe
                title="map"
                className="w-full h-64 rounded-xl"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d953.5942820565326!2d74.27208900000001!3d17.054196!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc174d13ce68a8d%3A0x700363551affb018!2sGovernment%20Girls%20Hostel!5e0!3m2!1sen!2sus!4v1752023198062!5m2!1sen!2sus"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bottom-0 left-0 right-0 bg-gradient-to-r from-gray-900 via-blue-900 to-indigo-900 text-white pt-6 sm:pt-8 pb-4 z-50">
        <div className="px-4 sm:px-8 md:px-16 lg:px-36">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Left: Center Branding */}
            <div className="flex items-center gap-3 w-full md:w-auto justify-center md:justify-start">
              <div className="relative">
                <img
                  src="/images/logo3.png"
                  alt="Prof. S. S. Patil Study Center"
                  className="w-8 h-8 drop-shadow-lg"
                />
                <div className="absolute -inset-1 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-full blur opacity-30"></div>
              </div>
              <div>
                <h5 className="text-base sm:text-lg font-bold bg-gradient-to-r from-blue-300 to-indigo-300 bg-clip-text text-transparent">
                  Prof. S. S. Patil Study Center
                </h5>
                <p className="text-gray-300 text-xs">
                  Excellence in Education & Comfort
                </p>
              </div>
            </div>

            {/* Center: Contact (Email + Phone) */}
            <div className="w-full md:flex-1 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6">
              <div className="flex items-center gap-1 text-gray-300 hover:text-white transition-colors duration-300">
                <MailOutlineIcon fontSize="small" />
                <span className="text-xs">admin@profsspatilstudycenter.com</span>
              </div>
              <div className="flex items-center gap-1 text-gray-300 hover:text-white transition-colors duration-300">
                <PhoneAndroidIcon fontSize="small" />
                <span className="text-xs">+91 9890741579 / 9766741579</span>
              </div>
            </div>

            {/* Right: Managed By MockingJay */}
            <div className="mj-managed-wrapper">
              <a
                href="https://mockingjay.tech"
                target="_blank"
                rel="noreferrer"
                className="mj-managed-link"
                title="Managed by MockingJay.tech"
              >
                <img
                  src="/images/newmanagedby.png"
                  alt="Managed by MockingJay.tech"
                  className="mj-managed-image"
                />
              </a>
            </div>
          </div>

          <div className="mt-4 pt-4 border-t border-gray-700 text-center">
            <p className="text-gray-400 text-xs">
              © 2025 Prof. S. S. Patil Study Center. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Individual Achievement Dialog */}
      {selectedAchievement && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[100] p-4"
          onClick={() => setSelectedAchievement(null)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-sm sm:max-w-md md:max-w-2xl w-full max-h-[90vh] overflow-y-auto relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={() => setSelectedAchievement(null)}
              className="absolute top-4 right-4 w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full shadow-lg border border-white/50 hover:bg-white hover:shadow-xl transition-all duration-300 z-20 flex items-center justify-center"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>

            {/* Image section */}
            {selectedAchievement.images && (
              <div className="relative aspect-square overflow-hidden rounded-t-2xl">
                <LazyLoadImage
                  src={selectedAchievement.images}
                  alt={selectedAchievement.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              </div>
            )}

            {/* Content section */}
            <div className="p-6 sm:p-8">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                <span className="text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider">
                  Student Achievement
                </span>
              </div>

              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                {selectedAchievement.title}
              </h3>

              <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6">
                {selectedAchievement.description}
              </p>

              <div className="flex items-center gap-2 text-sm text-gray-500">
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  ></path>
                </svg>
                <span>
                  {new Date(selectedAchievement.created_at).toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    }
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* All Achievements Dialog */}
      {showAllAchievements && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={() => setShowAllAchievements(false)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-sm sm:max-w-2xl md:max-w-4xl lg:max-w-6xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              {/* Header */}
              <div className="sticky top-0 bg-white/80 backdrop-blur-sm border-b border-gray-200 p-4 sm:p-6 rounded-t-2xl">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-yellow-600 to-orange-600 bg-clip-text text-transparent">
                      All Student Achievements
                    </h3>
                    <p className="text-gray-600 mt-2 text-sm sm:text-base">
                      Celebrating the success stories of our students
                    </p>
                  </div>
                  <button
                    onClick={() => setShowAllAchievements(false)}
                    className="w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full shadow-lg border border-white/50 hover:bg-white hover:shadow-xl transition-all duration-300 flex items-center justify-center"
                  >
                    <svg
                      className="w-6 h-6 text-gray-700"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>

              {/* Achievements Grid */}
              <div className="p-4 sm:p-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
                  {achievements.map((achievement, index) => (
                    <div
                      key={achievement.id}
                      className="group relative bg-white/80 backdrop-blur-sm rounded-xl shadow-lg border border-white/50 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden cursor-pointer"
                      onClick={() => setSelectedAchievement(achievement)}
                    >
                      {/* Achievement badge */}
                      <div className="absolute top-3 right-3 z-10">
                        <div className="w-10 h-10 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
                          <svg
                            className="w-5 h-5 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                            ></path>
                          </svg>
                        </div>
                      </div>

                      {/* Square Image section */}
                      <div className="relative aspect-square overflow-hidden rounded-t-xl">
                        {achievement.images ? (
                          <LazyLoadImage
                            src={achievement.images}
                            alt={achievement.title}
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                          />
                        ) : (
                          <div className="w-full h-full bg-gradient-to-br from-yellow-100 to-orange-100 flex items-center justify-center">
                            <svg
                              className="w-12 h-12 text-yellow-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                              ></path>
                            </svg>
                          </div>
                        )}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                      </div>

                      {/* Content section */}
                      <div className="p-4">
                        <h4 className="text-lg font-bold text-gray-800 mb-2 group-hover:text-yellow-600 transition-colors duration-300 line-clamp-2">
                          {achievement.title}
                        </h4>

                        <p className="text-gray-600 text-sm leading-relaxed mb-3 line-clamp-3">
                          {achievement.description}
                        </p>

                        <div className="flex items-center gap-2 text-xs text-gray-500">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            ></path>
                          </svg>
                          <span>
                            {new Date(
                              achievement.created_at
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            })}
                          </span>
                        </div>
                      </div>

                      {/* Hover effect overlay */}
                      <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/5 to-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Review Details Dialog */}
      <Dialog
        open={!!selectedReview}
        onClose={() => setSelectedReview(null)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, boxShadow: 4 },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#eff6ff",
            borderBottom: "1px solid #dbeafe",
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontWeight: 600,
            fontSize: "1.125rem",
            color: "#1e40af",
          }}
        >
          <PersonIcon sx={{ color: "#2563eb" }} />
          Review Details
        </DialogTitle>
        <DialogContent sx={{ p: { xs: 2, md: 3 } }}>
          {selectedReview && (
            <Box sx={{ py: 1 }}>
              {/* Header Section */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    color: "#1f2937",
                    mb: 1,
                    fontSize: { xs: "1.25rem", md: "1.5rem" },
                  }}
                >
                  {selectedReview.title}
                </Typography>

                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <Rating
                    value={selectedReview.rating}
                    readOnly
                    size="large"
                    sx={{
                      "& .MuiRating-iconFilled": {
                        color: "#fbbf24",
                      },
                      "& .MuiRating-iconEmpty": {
                        color: "#d1d5db",
                      },
                    }}
                  />
                  {/* <Chip
                    label={`${selectedReview.rating}/5`}
                    size="small"
                    sx={{
                      bgcolor: "#fef3c7",
                      color: "#d97706",
                      fontWeight: 600,
                    }}
                  /> */}
                </Box>
              </Box>

              <Divider sx={{ mb: 3 }} />

              {/* Review Content */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#374151",
                    lineHeight: 1.7,
                    fontSize: { xs: "0.875rem", md: "1rem" },
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {selectedReview.description}
                </Typography>
              </Box>

              <Divider sx={{ mb: 3 }} />

              {/* Reviewer Info */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  bgcolor: "#f8fafc",
                  borderRadius: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      bgcolor: "#3b82f6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: 600,
                      fontSize: "1.125rem",
                    }}
                  >
                    {selectedReview.name.charAt(0).toUpperCase()}
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: "#1f2937",
                        fontSize: { xs: "1rem", md: "1.125rem" },
                      }}
                    >
                      {selectedReview.name}
                    </Typography>
                  </Box>
                </Box>

                {selectedReview.created_at && (
                  <Typography
                    variant="body2"
                    sx={{ color: "#6b7280", fontSize: "0.875rem" }}
                  >
                    {new Date(selectedReview.created_at).toLocaleDateString(
                      "en-US",
                      {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }
                    )}
                  </Typography>
                )}
              </Box>
            </Box>
          )}
        </DialogContent>
        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
          <Button
            onClick={() => setSelectedReview(null)}
            variant="outlined"
            startIcon={<CloseIcon />}
            sx={{
              borderColor: "#d1d5db",
              color: "#374151",
              "&:hover": { bgcolor: "#f9fafb" },
            }}
          >
            Close
          </Button>
        </Box>
      </Dialog>

{/* Library Video Modal */}
{showLibraryVideo && (
  <div
    className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
    onClick={() => setShowLibraryVideo(false)}
  >
    <div
      className="w-full max-w-4xl bg-black rounded-2xl overflow-hidden shadow-2xl"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between px-4 py-3 bg-black">
        <p className="text-white font-semibold">Library Video</p>
        <button
          className="text-white/80 hover:text-white"
          onClick={() => setShowLibraryVideo(false)}
          aria-label="Close"
        >
          ✕
        </button>
      </div>

      <div className="relative w-full aspect-video">
        {/* Option A: YouTube Embed (recommended). Replace YOUR_VIDEO_ID */}
        <iframe
          className="absolute inset-0 w-full h-full"
          src="/videos/video.mp4"
          title="Library Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />

        {/* Option B: Local MP4 (uncomment if you use /public/videos/library.mp4) */}
        {/*
        <video className="absolute inset-0 w-full h-full" controls autoPlay>
          <source src="/videos/library.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        */}
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default HomePage;